import * as React from 'react'
import { Field } from '@metrisk/react_metrisk-components'

import './ClaimReasonInput.scss'

const ClaimReasonInput: React.FunctionComponent<ClaimReasonInput.IProps> = (props) => {
  const ERROR_STRING = 'Please enter a reason with at least 15 words'

  const [customReason, setCustomReason] = React.useState('')
  const [showTextArea, toggleTextArea] = React.useState(false)
  const [reasonSelected, setReasonSelected] = React.useState('')
  const [error, setError] = React.useState(ERROR_STRING)

  const { options, onChange } = props

  const onReasonChange = (reason: string) => {
    setReasonSelected(reason)
    if (reason === 'other') {
      onChange(null)
      toggleTextArea(true)
      return
    }
    onChange(reason)
    toggleTextArea(false)
  }

  const onCustomReasonChange = (customReasonInput: string) => {
    setCustomReason(customReasonInput)

    const wordCount = customReasonInput.trim().split(/\s+/).length

    if (wordCount < 15) {
      setError(ERROR_STRING)
      onChange(null)
      return
    }
    setError('')
    onChange(customReasonInput)
  }

  return (
    <div className="claim-reason-input">
      {options && (
        <Field
          fullWidth
          value={reasonSelected}
          type={'select'}
          options={options}
          id="claim-reason-select"
          onChange={onReasonChange}
          className="claim-reason-input__select"
        />
      )}
      {(showTextArea || !options) && (
        <Field
          fullWidth
          id="custom-reason-textarea"
          type={'textarea'}
          {...(!!customReason && { state: error ? 'Error' : 'Success' })}
          msg={error ? ERROR_STRING : ''}
          value={customReason}
          onChange={onCustomReasonChange}
        />
      )}
    </div>
  )
}

export default ClaimReasonInput
